import Component from '@bythepixel/component-loader';
import { update } from 'cart-localstorage';

export default class ChangeQuantity extends Component {
  static selector = '[data-comp-change-quantity]';

  constructor(containerEl) {
    super(containerEl);
    this.productId = this.$container.dataset.productId;
    this.quantityInput = this.$container.querySelector('[data-quantity]');
    this.events();
  }

  events() {
    this.quantityInput.addEventListener('change', (e) => {
      const inputQuantity = parseInt(e.target.value, 10);
      if (inputQuantity > 0) {
        update(this.productId, 'quantity', inputQuantity);
      } else if (inputQuantity < 1) {
        this.quantityInput.value = 1;
        update(this.productId, 'quantity', 1);
      }
    });
  }
}
